const angular = require('angular')
const forEach = require('lodash/forEach')

angular.module('hxphone.skin', [])
  .factory('Skin', [
    '$rootScope',
    '$utils',
    function ($rootScope, $utils) {
      let wholeCssText = ''
      return {
        reload: function(setting) {
          /** 替换 CSS 中的自定义属性 */
          /** replace custom properties for CSS */
          let customCSSStyleText = ''
          const regExpVar = /var\((.*?)\s*,\s*(.*?\)?)\)/gi

          forEach(document.styleSheets, function (sheet) {
            const rules = sheet.cssRules ? sheet.cssRules : sheet.rules
            forEach(rules, function (rule) {
              /var\(.*?\)?\)/gi.test(rule.cssText) && (
              /** iOS safari: var(--nav-bar-background-color, rgb(161, 0, 0)); */
              /** Chrome: var(--nav-bar-background-color, #a10000); */
                (customCSSStyleText += rule.cssText.replace(regExpVar, function ($0, $1, $2) {
                  return setting && setting[$1] ? setting[$1] : $2
                }))
              )
            })
          })

          const $body = angular.element(document.body)
          if (!customCSSStyleText) {
            /** fallback */
            wholeCssText = wholeCssText || $utils.$loadSync.loadCSS($body.find('link').attr('href'))
            const blockRegex = /(?:^|})[^}]*?var\((.*?)\s*,\s*(.*?\)?)\)[^}]*?}/gi
            const cssBlocksWithVariable = []
            let block = blockRegex.exec(wholeCssText)

            /** 获取所有含有 custom property 的样式块
            /** try to match all css blocks with custom properties */
            while (block !== null) {
              cssBlocksWithVariable.push(block[0])

              /** 需要 lastIndex 减一来匹配已经匹配的 } 字符 */
              /** need to delete lastIndex by one to match previous } character */
              blockRegex.lastIndex--

              block = blockRegex.exec(wholeCssText)
            }

            cssBlocksWithVariable.length > 0 && forEach(cssBlocksWithVariable, function (item) {
              customCSSStyleText += item.substr(1).replace(regExpVar, function ($0, $1, $2) {
                return setting && setting[$1] ? setting[$1] : $2
              })
            })
          }

          $body.find('.j-custom-style').remove()
          $body.append('<style class="j-custom-style" type="text/css">' + customCSSStyleText + '</style>')
        }
      }
    }
  ])



// WEBPACK FOOTER //
// ./src/js/skin/index.js